import React, { Component } from 'react';
import Input from 'react-toolbox/lib/input';
import { connect } from 'react-redux';
import * as actions from 'state/modules/popup';
import styles from './CarouselItem.css';

class CarouselItem extends Component {

  static propTypes = {
    CarouselItemData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    contactData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    ItemData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    strings: React.PropTypes.func,
    updateContactData: React.PropTypes.func,
    fetchContactData: React.PropTypes.func,
    carouselHeaderText: React.PropTypes.string,
    carousalHeaderTitle: React.PropTypes.string
  }
  state = {
    notesValue: '',
    leadsDescription: ''
  }
  componentWillMount() {
    if (this.props.ItemData !== undefined) {
      const promised = this.props.fetchContactData(this.props.ItemData.id);
      promised.then((response) => {
        this.setState({ notesValue: (response.cica_notes !== null) ?
          response.cica_notes : response.cica_comments,
          leadsDescription: response.description ? response.description : '' }, () => {
          console.log('leadsDescription', this.state.leadsDescription);
        });
      });
    }
  }
  carouselData = () => {
    const carouselItemData = this.props.CarouselItemData;
    return carouselItemData;
  }
  notesAction = (notesValue) => {
    this.setState({ notesValue });
    const contactData = this.props.contactData;
    contactData.cica_notes = notesValue;
    this.props.updateContactData(contactData);
  }
  render() {
    const warmLeadsTitle = '';
    const warmLeadsSubTitle = '';
    let campaignPurposeTitle = '';
    let campaignPurposeSubTitle = '';
    let warmLeadType = '';
    const { strings, carouselHeaderText, carousalHeaderTitle } = this.props;
    if (this.props.CarouselItemData) {
      switch (this.props.CarouselItemData.type) {
        case 'ropTable': {
          const tableDataObj = this.carouselData().tableData[0];
          const campaignPupose = tableDataObj.campaignPurpose;
          return (
            <div className={styles.carouselMainSection} >
              <div className={styles.carouselTableSection} >
                {
                  <div className={styles.flexContainer} >
                    {
                      this.carouselData().tableData.map((tableData, _index2) =>
                        <div className={styles.tableMainDiv} key={`maindiv, ${_index2}`}>
                          <table className={styles.tableStyle} key={_index2}>
                            <thead key={`thead, ${_index2}`}>
                              <tr className={styles.tableRowROP} key={`tr, ${_index2}`}>
                                {
                                  tableData.header.map((header, _index3) =>
                                    <td className={styles.tableDivInnerHeader} key={`td, ${_index3}`}>
                                      <span className={styles.boldSpanFontROP} key={`span_, ${_index3}`}>{header}</span>
                                    </td>
                                  )}
                              </tr>
                            </thead>
                            <tbody key={`tbody, ${_index2}`}>
                              {
                                tableData.body.map((ropRow, _index3) =>
                                  <tr key={_index3} className={styles.tableRowROP}>
                                    {
                                      Object.keys(ropRow).map((ropCell, _index4) =>
                                        <td className={styles.tableDivInnerROP} key={`td, ${_index4}`}>
                                          {ropCell === 'cica_roppolicynumber' &&
                                            <span className={styles.bodySpanFontROP}>
                                              <input
                                                type="checkbox"
                                                value="selected"
                                                id={`input_in_${_index2}_${_index3}_${_index4}`}
                                                className={styles.boldAnchorSpanFont}
                                                key={`input_in_${_index4}`}
                                              />
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`}>
                                                {ropRow[ropCell]}
                                              </label>
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`} className={styles.starMasks} key={`span_, ${_index3}, _star`}>**</label>
                                            </span>
                                          }
                                          {ropCell !== 'cica_roppolicynumber' &&
                                            <span className={styles.bodySpanFontROP} key={`span_, ${_index4}`}>{ropRow[ropCell]}</span>
                                          }

                                        </td>
                                      )
                                    }
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    <div className={styles.belowTable}>
                      <span className={styles.subSpanFontROP} key={'staticForMoreDetailsROP'}>{strings.forMoreInfo}</span>
                    </div>
                    <div className={styles.belowTableROP}>
                      <span className={styles.bigBoldSpanFontROP} key={'staticROPCampaignHeader'}>{strings.campaignPurpose}</span>
                      <span className={styles.subSpanFontSubROP} key={'staticROPCampaignText'}>{`${campaignPupose}`}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          );
        }
        case 'table':
          return (
            <div className={styles.carouselMainSection} >
              <div className={styles.carouselTableSection} >
                {
                  <div className={styles.flexContainer} >
                    {
                      this.carouselData().tableData.map((tableData, _index2) =>
                        <div className={styles.tableMainDiv} key={`maindiv, ${_index2}`}>
                          <div className={styles.tableTitleDiv} key={`tabletitle, ${_index2}`}>
                            <span className={styles.tableTitleSpan} key={`tableTitleSpan, ${_index2}`}>{tableData.tableTitle}</span>
                          </div>
                          <table className={styles.tableStyle} key={_index2}>
                            <thead key={`thead, ${_index2}`}>
                              <tr className={styles.tableRow} key={`tr, ${_index2}`}>
                                {
                                  tableData.header.map((subItems, _index3) =>
                                    <td className={styles.tableDivInner} key={`td, ${_index3}`}>
                                      <span className={styles.boldSpanFont} key={`span_, ${_index3}`}>{subItems}</span>
                                    </td>
                                  )}
                              </tr>
                            </thead>
                            <tbody key={`tbody, ${_index2}`}>
                              {
                                tableData.body.map((tableBodyRows, _index3) =>
                                  <tr key={_index3} className={styles.tableRow}>
                                    {
                                      tableBodyRows.map((tableBodyItems, _index4) =>
                                        <td className={styles.tableDivInner} key={`td, ${_index4}`}>
                                          {tableBodyItems.name === 'policyNumber' &&
                                            <span className={styles.bodySpanFont}>
                                              <input
                                                type="checkbox"
                                                value="selected"
                                                id={`input_in_${_index2}_${_index3}_${_index4}`}
                                                className={styles.boldAnchorSpanFont}
                                                key={`inpur_in_${_index4}`}
                                              />
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`}>
                                                {tableBodyItems.value}
                                              </label>
                                              <label htmlFor={`input_in_${_index2}_${_index3}_${_index4}`} className={styles.starMasks} key={`span_, ${_index3}, _star`}>**</label>
                                            </span>

                                          }
                                          {tableBodyItems.name !== 'policyNumber' &&
                                            <span className={styles.bodySpanFont} key={`span_, ${_index4}`}>{tableBodyItems.value}</span>
                                          }
                                        </td>
                                      )
                                    }
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    <div className={styles.belowTable}>
                      {
                        this.carouselData().footerData.map((footerDataRows, _index3) =>
                          <div key={`div, ${_index3}`} >
                            <span className={_index3 === 0 ? styles.bigBoldSpanFont : styles.boldSpanFont} key={`span1_, ${_index3}`}>{footerDataRows.title}</span>
                            <span className={styles.subSpanFont} key={`span2_, ${_index3}`}>{footerDataRows.subTitle}</span>
                          </div>
                        )}
                    </div>
                  </div>
                }
              </div>
            </div>
          );
        case 'OtherCampaignsFlexDivs':
          return (
            <div className={styles.carouselMainDivSection}>
              <div className={styles.carouselMainSectionNROP} >
                {
                  this.props.CarouselItemData &&
                  this.carouselData().subItems.map((subItems, _index2) =>
                    <div className={styles.tableStyle} key={_index2}>
                      {subItems.subElements.map((subElements, _index3) => {
                        if (subElements.title === 'Campaign Purpose:' || subElements.title === 'Propósito de la campaña:') {
                          campaignPurposeTitle = subElements.title;
                          campaignPurposeSubTitle = subElements.subTitle;
                          return '';
                        }
                        return (
                          <div className={styles.labelSubElement} key={_index3}>
                            <div
                              className={styles.labelCampaignTitle}
                              key={`subQuestion, ${_index3}!`}
                            >
                              {subElements.title}
                            </div>
                            <div
                              className={(subElements.title === 'Campaign Name:' || subElements.title === 'Nombre de campaña:') ? styles.subLabelCampaignName : styles.labelCampaignSubTitle}
                              key={`subAnswer, ${_index3}!`}
                            >
                              {subElements.subTitle}
                            </div>
                          </div>
                        );
                      }
                      )}
                    </div>
                  )}
              </div>
              {
                (campaignPurposeTitle !== '' && campaignPurposeSubTitle !== '') &&
                <div className={styles.belowTableDiv}>
                  <div>
                    <span className={styles.subSpanFontROP} key={'staticForMoreDetailsCamp'}>{strings.forMoreInfo}</span>
                  </div>
                  <div className={styles.spacer} />
                  <div className={styles.bigBoldSpanFontText}>
                    {campaignPurposeTitle}
                  </div>
                  <div className={styles.labelSubAnswerWarm}>
                    {campaignPurposeSubTitle}
                  </div>
                </div>
              }
            </div>
          );
        default:
          return (
            <div className={styles.carouselMainDivSection}>
              <div className={styles.carouselMainSectionContainer} style={carouselHeaderText && carouselHeaderText === strings.other ? { flex: '0.5' } : {}}>
                <div className={styles.carouselMainSection} >
                  {
                    this.props.CarouselItemData &&
                    this.props.CarouselItemData.map((subItems, _index2) =>
                      <div className={styles.tableStyle} key={_index2}>
                        {subItems.subElements.map((subElements, _index3) => {
                          if (subElements.subTitle === 'Warm') {
                            warmLeadType = subElements.subTitle;
                          }
                          return (
                            <div className={styles.labelSubElement} key={_index3}>
                              <div
                                className={styles.labelSubQuestion}
                                key={`subQuestion, ${_index3}!`}
                              >
                                {subElements.title}
                              </div>
                              <div
                                className={styles.labelSubAnswer}
                                key={`subAnswer, ${_index3}!`}
                              >
                                {subElements.subTitle}
                              </div>
                            </div>
                          );
                        }
                        )}
                      </div>
                    )}
                </div>
              </div>
              <div className={styles.belowTableData}>
                {
                  (warmLeadsTitle !== '' && warmLeadsSubTitle !== '') &&
                  <div className={styles.belowTableDataChild}>
                    <div className={styles.bigBoldxrntText}>
                      {warmLeadsTitle}
                    </div>
                    <div className={styles.labelSubAnswerWarm}>
                      {warmLeadsSubTitle}
                    </div>
                  </div>
                }
                {
                  carousalHeaderTitle === strings.other && warmLeadType === 'Warm' &&
                  <div className={styles.belowTableNoteDiv}>
                    <div className={styles.labelSubQuestion}>
                      {strings.leadsDescription}
                    </div>
                    <div className={styles.labelSubAnswer}>
                      <label htmlFor={strings.leadsDescription}>
                        {this.state.leadsDescription}
                      </label>
                    </div>
                  </div>
                }
                {
                  carousalHeaderTitle === strings.contactInfo &&
                  <div className={styles.belowTableNoteDiv}>
                    <div className={styles.bigBoldSpanFontText}>
                      {strings.notes}
                    </div>
                    <div className={styles.subSpanFont}>
                      <Input
                        type="text"
                        multiline
                        name={'Notes'}
                        display="flex"
                        theme={styles}
                        floating={false}
                        maxLength={250}
                        value={this.state.notesValue}
                        onChange={this.notesAction}
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          );
      }
    }
    return '';
  }
}
const mapStateToProps = state => ({
  contactData: state.popup.contactData,
});
export default connect(mapStateToProps, actions)(CarouselItem);



// WEBPACK FOOTER //
// ./src/components/CarouselItem/CarouselItem.js